// removed by extract-text-webpack-plugin
module.exports = {"root":"_V6CwQ","icon":"_3Jn7S","title":"_3zrCG","description":"_3ov44"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Reminder/Reminder.scss
// module id = 1621
// module chunks = 1